export const isNonFrontalImagePresent = (activeViewport, nonFrontalImages, setNonFrontalImageId) => {
    // const viewport = await getViewport(activeViewportIndex);
    const imageURL = activeViewport.getCurrentImageId();
    for (let i = 0; i < nonFrontalImages.length; i++) {
        if (nonFrontalImages[i].imageUrl === imageURL) {
            setNonFrontalImageId(nonFrontalImages[i].imageId);
            return true;
        }
    }
    setNonFrontalImageId(null);
    return false;
};
